import { useState } from "react";

import { isEmpty, keyBy } from "lodash";
import debounce from "lodash/debounce";
import useSWR from "swr";

import Select, { SelectOption } from "components/uikit/select";

import { useApplicationContext } from "contexts/app";

import { Driver } from "types";

import { DEFAULT_PAGE_SIZE } from "utils/http-client-utils";

interface SelectDrivers {
  driver?: string;
  onSearch?: (e: any) => void;
  loading?: boolean;
  onCallback?: (v: Driver) => void;
  placeholder?: string;
  showSearch?: boolean;
  filterOption?: boolean | any;
  allowClear?: boolean;
  size?: any;
  suffixIcon?: boolean;
  disabled?: boolean;
}

const SelectDrivers = ({ driver, onSearch, loading, onCallback, ...props }: SelectDrivers) => {
  const [search, setSearch] = useState(false);
  const { session } = useApplicationContext();

  const defaultQuery = `?account=${session?.accountId}&active=True&ordering=name&page_size=${DEFAULT_PAGE_SIZE}`;
  const searchQuery = defaultQuery + `&search=${search}`;
  const url = search ? `drivers/${searchQuery}` : `drivers/${defaultQuery}`;

  const { data } = useSWR(url);

  const keyedData = keyBy(data, "url");
  const doesNotExist = isEmpty(keyedData[driver as string]);
  const { data: driverData } = useSWR(doesNotExist && driver);

  if (isEmpty(search) && data && driverData) {
    data.unshift(driverData);
  }

  const onSearchDefault = debounce((value) => setSearch(value), 500);

  return (
    <Select
      {...props}
      showSearch
      onSearch={onSearch || onSearchDefault}
      loading={loading}
      onSelect={(e) => {
        const driverData = data?.find((d: { url: any }) => d.url === e);
        onCallback && onCallback(driverData);
      }}
      data-testid="select-drivers"
      filterOption={false}
    >
      {data?.map(({ name, url }: { name: string; url: string }) => (
        <SelectOption key={url} value={url}>
          {name}
        </SelectOption>
      ))}
    </Select>
  );
};

export default SelectDrivers;
